var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Container, Form, FormGroup, Input, Label } from 'reactstrap';
import { T } from 'helpers/i18n';
import { StretchOta } from '../Model';
var StretchOtas = /** @class */ (function (_super) {
    __extends(StretchOtas, _super);
    function StretchOtas(props) {
        var _this = _super.call(this, props) || this;
        _this.getNameStretchInOta = function (ota_id, stretchOtas) {
            var stretchOta = stretchOtas.find(function (value) {
                return value.ota_id === ota_id;
            });
            return stretchOta ? stretchOta.nameStretchInOta : '';
        };
        _this.handleOnChange = function (event, ota) {
            var stretchOtas = _this.state.stretchOtas;
            var index = stretchOtas.findIndex(function (stretchOta) { return stretchOta.ota_id === ota.id; });
            if (index >= 0) {
                stretchOtas[index].nameStretchInOta = event.target.value;
            }
            else {
                var stretchOta = new StretchOta({
                    nameStretchInOta: event.target.value,
                    ota_id: ota.id,
                    description: ota.description,
                    disabled_at: ota.disabled_at,
                    nameOta: ota.nameOta,
                    stretch_id: _this.props.stretch.id
                });
                stretchOtas.push(stretchOta);
            }
            // this.setState({stretchOtas})
            _this.setState({ stretchOtas: stretchOtas }, function () {
                if (_this.props.onChange) {
                    _this.props.onChange(stretchOtas);
                }
            });
        };
        _this.state = {
            stretchOtas: props.stretchOtas || []
        };
        return _this;
    }
    StretchOtas.prototype.render = function () {
        var _this = this;
        var otas = this.props.otas;
        var stretchOtas = this.state.stretchOtas;
        return (React.createElement(Container, null, otas.map(function (ota, index) {
            return React.createElement(StretchOtaView, { key: ota.id, ota: ota, value: _this.getNameStretchInOta(ota.id, stretchOtas), onChange: function (event) { return _this.handleOnChange(event, ota); } });
        })));
    };
    StretchOtas = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.store.otaStore.read().then(function (otas) { return ({ otas: otas }); })
        ]; }),
        observer
    ], StretchOtas);
    return StretchOtas;
}(Component));
export default StretchOtas;
var StretchOtaView = function (_a) {
    var ota = _a.ota, onChange = _a.onChange, value = _a.value;
    return (React.createElement(Form, { className: "mt-3" },
        React.createElement(FormGroup, null,
            React.createElement(Label, { for: "exampleEmail" }, ota.nameOta),
            React.createElement(Input, { placeholder: "".concat(T('nameServiceIn'), " ").concat(ota.nameOta), value: value, onChange: onChange }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/StretchOtas.tsx
// module id = 1413
// module chunks = 0